import { render, staticRenderFns } from "./list-detail-panel-empty.vue?vue&type=template&id=b9c5ed14&scoped=true&"
import script from "./list-detail-panel-empty.vue?vue&type=script&lang=ts&"
export * from "./list-detail-panel-empty.vue?vue&type=script&lang=ts&"
import style0 from "./list-detail-panel-empty.vue?vue&type=style&index=0&id=b9c5ed14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c5ed14",
  null
  
)

export default component.exports